import React from "react";

import destination_1 from "../../public/wheretogo-krkonose/mumlavskyvodopad/destination_1.png";
import destination_2 from "../../public/wheretogo-krkonose/mumlavskyvodopad/destination_2.png";
import destination_3 from "../../public/wheretogo-krkonose/mumlavskyvodopad/destination_3.png";
import destination_4 from "../../public/wheretogo-krkonose/mumlavskyvodopad/destination_4.png";
import destination_5 from "../../public/wheretogo-krkonose/mumlavskyvodopad/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-krkonose/mumlavskyvodopad/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-krkonose/mumlavskyvodopad/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-krkonose/mumlavskyvodopad/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-krkonose/mumlavskyvodopad/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const MumlavskyVodopad = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Mumlavský vodopád</h1>
            <p>
              Jedná se o jeden z nejmohutnějších vodopádů v České republice a
              díky tomu je považován za jeden z nejkrásnějších a turisty
              nejvyhledávanějších vodopádů v Čechách.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>koupání</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>horské kolo</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>nádherná příroda</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Voda pada z velké výšky a proto v korytě vyhloubila obří kotle
                  tzv. Čertova oka (Čertovy hrnce)
                </li>
                <li>
                  Po většinu roku voda padá bystře z 10 metrové výšky dolů, ale
                  jakmile přijde zima, mráz promění vodu v led a vykouzlí tak
                  mohutný ledopád, originální dílo přírody.
                </li>
                <li>
                  Největší prohlubní, vytvořených erozí, dosahuje v průměru až 6
                  metrů a hloubky 3 metrů.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MumlavskyVodopad;
